<template>
  <div class="footer-modal">
    <!-- About Moments Modal -->
    <div
      class="modal fade"
      id="about-moments"
      tabindex="-1"
      aria-labelledby="about-moments"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div
            class="
              modal-body
              d-flex
              align-items-center
              flex-column
              postion-relative
            "
          >
            <img
              src="@/img/tnc_close.png"
              alt="footer modal close"
              class="tnc-close img-fluid"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div class="text-content">
              <h4 class="text-uppercase text-center pb-5">About Moments</h4>
              <p class="font-16 pb-4">
                Over at Passionation.co, we believe in the strength of community
                and the rewards it holds. Echoing that belief closely, Moments
                was created to bring together a passionate community of amazing
                brands – both established and upcoming local makers and
                creators, to form meaningful social and discovery commerce
                experiences for both sellers and buyers.
              </p>
              <p class="font-16 pb-4">
                Moments also aims to revolutionise the way consumers shop by
                providing a unique interactive, content-driven, discovery-based
                shopping experience to easily find niched and quality products
                for their loved ones. The close collaborations we have with our
                merchants help to create an ecosystem of diverse “direct to
                consumer” products at highly competitive prices.
              </p>
              <p class="font-16 pb-4">
                We believe every product tells a story. And it is an important
                tool to connect people, make memories, and transform
                relationships. Hence, we at Moments work to enrich this
                experience for you.
              </p>
              <p class="font-16 pb-4">
                Whether you’re buying something to treat yourself, sending a
                gift to a new neighbour or to a newly married couple,
                celebrating a birthday, or letting a friend know you’re thinking
                of them, Moments is honoured to help.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TnC Modal -->
    <div
      class="modal fade"
      id="tnc"
      tabindex="-1"
      aria-labelledby="tnc"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div
            class="
              modal-body
              d-flex
              align-items-center
              flex-column
              postion-relative
            "
          >
            <img
              src="@/img/tnc_close.png"
              alt="footer modal close"
              class="tnc-close img-fluid"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div class="text-content">
              <h4 class="text-uppercase text-center pb-5">
                Terms & Conditions
              </h4>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  Herbalicious2u (Power by Passionation)
                </p>
                <p class="font-16 pb-3">
                  The General Online Terms and Conditions (“General Terms”) of
                  Herbalicious2u Powered by Passionation (“Online Store” or
                  “Website”) shall apply exclusively to the agreements concluded
                  by us in the version which was valid at the time of the
                  conclusion of a transaction between us and the Customer. We
                  shall (i) reserve the express right to make the necessary
                  modifications to the General Terms; and (ii) oppose any
                  regulations in opposition hereto.
                </p>
                <p class="font-16 pb-3">
                  The respective current version of the General Terms can be
                  viewed under the keyword 'General Online Terms and
                  Conditions'. During the ordering procedure, the Customer will
                  receive continuous options to inspect, print out or store the
                  General Terms. Upon conclusion of the transaction, the
                  Customer shall be deemed to accept the General Terms.
                </p>
                <p class="font-16">
                  In the event, ordering procedures or any other matters require
                  verbal collateral agreement, it must be documented on a
                  continuous data carrier, such as an email. All modifications
                  to the General Terms, including this clause, as well as
                  agreements on delivery deadlines and dates, are also subject
                  to our written confirmation.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">LEGAL INFORMATION</p>
                <p class="font-16 pb-3">
                  The website is Powered by Passionation.
                </p>
                <p class="font-16 pb-3">
                  Unless otherwise noted, all content posted on the web site is:
                </p>
                <p class="font-16 pb-3">Copyright © 2021 Passionation</p>
                <p class="font-16">
                  The web site in its entirety, including all content and design
                  featured, including images, pictures, artwork, graphics,
                  photography, text, and the like, and all rights therein,
                  including copyrights, trademarks and/or other intellectual
                  property, are owned, controlled, or licensed by Herbalicious2u
                  (or Passionation) and its affiliates.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">USE OF THE WEB SITE</p>
                <p class="font-16 pb-3">
                  The contents of the Website and the Website as a whole are
                  intended solely for your personal and non-commercial use. It
                  is prohibited to use the Website and/or any content posted
                  therein for any purpose other than personal and non-commercial
                  use without the written permission of Herbalicious2u and
                  Passionation. You are not allowed to reproduce, publicly
                  display, modify, edit, adapt, distribute, sell, transmit or
                  otherwise use any of the materials or content posted therein
                  for any commercial purpose without the authorization from
                  Herbalicious2u and Passionation. Herbalicious2u and
                  Passionation grants a limited, non-exclusive, restricted,
                  non-transferable, non-sublicensable, revocable license
                  allowing you to electronically copy content displayed on the
                  Website for your personal and non-commercial use. All rights
                  are reserved to Herbalicious2u and Passionation.
                </p>
                <p class="font-16 pb-3">Notice:</p>
                <p class="font-16">
                  In practice of good faith, while using or visiting the
                  Website, you agree that you (i) will not access or use the
                  Website in any manner that could damage, disable, impair or
                  cause undue burden on the Website, including its host,
                  servers, network, systems or other users; (ii) will not
                  attempt to interfere physically, electronically or in any way
                  with the operation of the Website; (iii) will not transmit any
                  computer virus, worm, spider, Trojan horse, robot or any other
                  automated mechanism to access the Website and/or its servers
                  or systems; (iv) will not engage in flooding, spamming,
                  mail-bombing, crashing or otherwise sending unsolicited e-mail
                  to us or any party associated with; (v) will not attempt to
                  access data that is not intended for your use; (vi) will not
                  attempt to log on to a server, network or account belonging to
                  Herbalicious2u and Passionation that you are not authorized to
                  access; (vii) will not probe, scan or test the vulnerability
                  of any system or network related in any way to the Website
                  under any circumstances without authorization; (viii) will not
                  harass in any manner or form on the Website; (ix) will not
                  impersonate any member of Herbalicious2u and Passionation,
                  employees of Herbalicious2u and Passionation, host or
                  representative of Herbalicious2u and Passionation for any
                  purpose; (x) will not perform any actions which is obscene,
                  defamatory, threatening, invasive of privacy or actions may
                  otherwise give rise to liability or violate any law; and (xi)
                  will not use the Website to solicit others to join or become
                  members of any other commercial online service or
                  organization.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  OFFERS, ORDERS AND CONCLUSION OF TRANSACTION
                </p>
                <p class="font-16 pb-3">
                  The presentation of products in the Online Store does not
                  represent a legally binding offer to any party, but a
                  non-binding online catalogue. We shall exercise fair judgment
                  to determine whether an order will be accepted. In the event,
                  the online order cannot be fulfilled by us, we will notify the
                  respective Customer immediately by email provided by the
                  Customer.
                </p>
                <p class="font-16 pb-3">
                  All products selected by the Customer will be added into the
                  “Shopping Bag” prior proceeding to the next phase with the
                  options to verify the correctness of his/her order. Prior to
                  concluding their order, the Customer is given a selection of
                  payment options and makes the necessary checking and/or
                  amendment of their order again.
                </p>
                <p class="font-16">
                  Prior to making a legally binding offer to conclude the
                  transaction, the Customer will have to accept the General
                  Terms. Upon conclusion of the order, the Customer will receive
                  an order confirmation by email, a means to notify the Customer
                  that the order was duly transmitted. Upon receiving
                  confirmation the delivery of the merchandise is completed, the
                  contract of purchase is legally completed.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">PRICING POLICY</p>
                <p class="font-16">
                  At Herbalicious2u (Powered by Passionation), we are committed
                  to offer products on-line, service and convenience at
                  compelling prices. We may offer limited time promotional price
                  campaigns at our discretion.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">PRICES AND PAYMENTS</p>
                <p class="font-16 pb-3">
                  The price of the products is as per listing, however, the
                  applicable final price payable is the total listed price
                  during checkout. Optional discounting does not exist unless
                  otherwise promoted. All additional costs, such as import sales
                  tax, custom tax or duty shall be borne by the Customer.
                </p>
                <p class="font-16 pb-3">
                  The following payment modes are available:
                </p>
                <p class="font-16 pb-3">
                  Credit card: With this mode of payment, the Customer will be
                  directed to the relevant page to fill the required field, and
                  at the time of the online purchase the amount will be reserved
                  on the Customer's credit card. The credit cards will be
                  actually debited parallel to preparing the delivery
                  confirmation by e-mail. Upon successful payment, the Customer
                  will be redirected back to the Online Store. Subsequently, the
                  Customer will receive an email confirmation from us.
                </p>
                <p class="font-16 pb-3">
                  PayPal: With this mode of payment, the Customer will be
                  directed to the PayPal payment page. The Customer will be
                  required to key in the relevant information required by PayPal
                  before effecting the payment to us. Upon successful payment,
                  the Customer will be redirected back to the Online Store.
                  Subsequently, the Customer will receive an email confirmation
                  from us.
                </p>
                <p class="font-16">
                  Passionation reserves the right to include/exclude certain
                  modes of payment at discretion.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">DELIVERIES</p>
                <p class="font-16 pb-3">
                  All products will be delivered to the shipping address
                  provided by the Customer registered in our database. In the
                  event, delays or other disadvantages incurred due to incorrect
                  information provided by the Customer, Herbalicious2u and
                  Passionation should not be liable for those costs and
                  liabilities associated with it.
                </p>
                <p class="font-16 pb-3">
                  The estimated time of arrivals of your purchases may be
                  reasonably affected and/or extended by various reasons, such
                  as the weather, natural disasters, custom authorities, and
                  other uncontrollable factors which may render delivery
                  extremely difficult (“Extreme Factor”) on which Herbalicious2u
                  and Passionation have no influence. Under such circumstances,
                  Herbalicious2u (or Passionation) shall notify the Customer
                  immediately via email registered in our database. In the case
                  of a withdrawal by Herbalicious2u (or Passionation), the
                  Customer will be reimbursed the affected payments in the form
                  of Herbalicious2u credit or bank transfer.
                </p>
                <p class="font-16 pb-3">
                  Delivery charges may depend on the order quantity and delivery
                  destination. The type of delivery will be chosen by
                  Herbalicious2u in its own fair judgment. All items purchased
                  will be delivered in normal household quantities via courier
                  services hired/contracted during business hours and working
                  days.
                </p>
                <p class="font-16">
                  If an item cannot be delivered from our store, we shall not be
                  held liable for the performance of the contract. In the case
                  of non-deliverability due to Extreme Factors, the Customer
                  will be notified immediately and any payments in return shall
                  be returned in the form of Herbalicious2u credit or Bank
                  Transfer.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">RESERVATION OF TITLE</p>
                <p class="font-16">
                  All products shall remain as the property of Herbalicious2u
                  and Passionation until the Customer has made full payment.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">PURCHASE ON TRIAL</p>
                <p class="font-16 pb-3">
                  If the Customer has purchased a product, the purchased
                  products can be returned with specific reasonable reason
                  within stipulated number of days of receiving it (based on the
                  shipping tracking). Please refer to our Customer Service.
                </p>
                <p class="font-16 pb-3">Notice:</p>
                <p class="font-16">Terms and conditions may apply.</p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">THIRD PARTY LINKS</p>
                <p class="font-16 pb-3">
                  To provide a better service and increased value to our
                  Customers, we at Herbalicious2u (or Passionation) may have
                  third-party websites to link to from its own Website.
                  Herbalicious2u and Passionation expressly declare we do not
                  have any influence on these designs and contents and have no
                  control over these linked sites, all of which have separate
                  privacy, security, and data collection practices, independent
                  of Herbalicious2u and Passionation. We shall not be held any
                  responsible for these contents, independent policies or
                  actions. These linked sites are only for your convenience and
                  therefore you access them at your own risk.
                </p>
                <p class="font-16 pb-3">
                  You further agree that Herbalicious2u and Passionation takes
                  no responsibility for third party advertisements posted on
                  this Website, nor does it take any responsibility for the
                  goods or services provided by these advertisers.
                </p>
                <p class="font-16 pb-3">
                  Herbalicious2u and Passionation is not responsible for the
                  conduct, whether online or offline, of any user of the
                  Website. Herbalicious2u and Passionation assumes no
                  responsibility for any error, omission, interruption,
                  deletion, defect, delay in operation or transmission,
                  communications line failure, theft or destruction or
                  unauthorized access to, or alteration of, any user
                  communication. Herbalicious2u and Passionation is not
                  responsible for any problems or technical malfunction of any
                  telephone network or lines, computer online systems, servers
                  or providers, computer equipment, software, failure of any
                  e-mail or electronic players due to technical problems or
                  traffic congestion on the Internet or on any of the website or
                  combination thereof, including any injury or damage to users
                  or to any person’s computer related to or resulting from
                  participation or downloading materials in connection with
                  those website.
                </p>
                <p class="font-16">
                  Herbalicious2u and Passionation hereby expressly disassociates
                  from all contents of orders linked to third-party websites and
                  does not make these its own, and advise visitors to beware of
                  the risk of visiting them.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">COPYRIGHTED MEDIAS</p>
                <p class="font-16 pb-3">
                  All images, photographs and videos are copyrighted
                  ("Copyrighted Medias"). The use of these Copyrighted Medias
                  without express permission by us is prohibited. We reserve to
                  assert all claims in accordance with the relevant copyright
                  Act.
                </p>
                <p class="font-16 pb-3">Notice:</p>
                <p class="font-16">
                  We try to provide as accurately as possible the colors and
                  description of the products displayed in the Online Store.
                  However, please take note on the coloration of the product
                  images presented in the Online Store are contingent/subject
                  upon the respective settings of the Customer's screen and
                  monitor, the difference in settings may vary slightly from the
                  color of the actual product supplied.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">TYPOGRAPHICAL ERRORS</p>
                <p class="font-16 pb-3">
                  We endeavour to provide the most accurate and reliable
                  information at all times, despite cautionary effort,
                  information may contain unintended typographical errors or
                  inaccuracies. Herbalicious2u and Passionation reserve the
                  right to correct any errors, inaccuracies or omissions and to
                  change and update information at any time without prior notice
                  (including after you have submitted your order). Please note
                  that such errors, inaccuracies or omissions may relate to
                  product description, pricing and availability. We sincerely
                  apologize for any inconvenience caused.
                </p>
                <p class="font-16 pb-3">Notice:</p>
                <p class="font-16 pb-3">
                  In the event a product is listed at an incorrect price due to
                  typographical error or systems error, Herbalicious2u (or
                  Passionation) shall have the right to refuse or cancel any
                  orders placed for products listed at the incorrect price.
                </p>
                <p class="font-16">
                  Herbalicious2u (or Passionation) shall have the right to
                  refuse or cancel any such orders whether or not the order has
                  been confirmed and your credit card charged. In the event
                  there is a cancellation due to typographical errors by us, you
                  will be refunded.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">DATA PROTECTION</p>
                <p class="font-16 pb-3">
                  In data protection concerns during data processing, protective
                  measures will be taken into account in accordance with the
                  legal regulations. All information collected will be treated
                  confidentially, including Personal Information, order
                  information and transactions information handling. In
                  principle, all personal data will be treated confidentially.
                  These data requirements for handling transactions will be
                  stored.
                </p>
                <p class="font-16 pb-3">Notice:</p>
                <p class="font-16">
                  Certain information may be collected and processed for our own
                  marketing purposes. The onus is on the Customer to notify us,
                  in the event, they wish to oppose and/or revoke the use of,
                  processing and/or transmission of his/her data for marketing
                  purposes. Upon receipt of such requests, we will take the
                  necessary effort and will no longer use and process the data
                  in question for marketing purposes. These may include the
                  discontinuation of the sending of advertising material and/or
                  no longer disseminate the data for marketing purposes, if
                  requested.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS
                </p>
                <p class="font-16 pb-3">
                  All comments, feedback, suggestions, ideas, and other
                  submissions disclosed, submitted or offered to Herbalicious2u
                  (or Passionation) or otherwise disclosed, submitted or offered
                  in connection with your use of this Website (collectively, the
                  “Comments”) shall be and remain the property of Herbalicious2
                  and Passionation. By submitting such Comments by you, you
                  agree that, (i) no Comments submitted by you to the Website
                  will violate any right of any third party, including
                  copyright, trademark, privacy or other personal or proprietary
                  rights(s); and (ii) no Comments submitted by you to the
                  Website will be or contain obscene material, abusive or
                  defamatory. You are and shall remain solely responsible for
                  the content of any Comments you make.
                </p>
                <p class="font-16 pb-3">Notice:</p>
                <p class="font-16">
                  Herbalicious2u and Passionation may deliver notice to our
                  Customer by means of electronic mail registered with us.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">COPYRIGHT POLICY FOR THE WEBSITE</p>
                <p class="font-16">
                  We are strictly against any action which includes posting,
                  modifying, distributing, transmitting, reproducing, publicly
                  display or use in any way any copyrighted material,
                  trademarks, or other proprietary material or information
                  belonging to any third party without obtaining the prior
                  written consent of the owner the rights in and to such
                  proprietary material or information. Herbalicious2u and
                  Passionation have the rights to terminate the privileges of
                  any user of the Website or member who infringes the copyright
                  rights of others upon receipt of prompt notification by the
                  copyright owner or the copyright owner’s legal agent.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  LIMITATION OF LIABILITY/ DISCLAIMER
                </p>
                <p class="font-16 pb-3">
                  As a visitor to and a user of the Website, you agree that your
                  access will be subject to the General Terms set forth and that
                  access is undertaken at your own risk. Herbalicious2u and
                  Passionation shall not be liable for damages of any kind
                  related to your use of or inability to access the Website. In
                  no event shall Herbalicious2u (or Passionation) be liable to
                  you or any third party for any incidental, special, punitive,
                  consequential or indirect damages or monetary losses from your
                  use of the services, even if Herbalicious2u (or Passionation)
                  has been advised of the possibility of such damages.
                  Notwithstanding anything to the contrary contained herein,
                  Herbalicious2u’s and Passionation’s liability to you for any
                  cause whatsoever, will at all times be limited to the amount
                  paid, if any, by you to Herbalicious2u and Passionation for
                  products purchased.
                </p>
                <p class="font-16 pb-3">
                  Herbalicious2u and Passionation will not be responsible for
                  any problems or technical malfunction of any telephone network
                  or lines, computer online systems, servers or providers,
                  computer equipment, software, failure of any e-mail due to
                  technical problems or traffic congestion on the Internet or on
                  any of the website or combination thereof, including any
                  injury or damage to users or to any person’s computer related
                  to or resulting from participation or downloading materials in
                  connection with the Website. Under no circumstances shall v be
                  responsible for any loss or damage, including personal injury
                  or death, resulting from use of the Website, from any content
                  posted on or through the Website, or from the conduct of any
                  users of the Website, whether online or offline.
                </p>
                <p class="font-16">
                  YOU UNDERSTAND, ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE
                  WEBSITE IS AT YOUR OWN RISK.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">INDEMNIFICATION</p>
                <p class="font-16 pb-3">
                  By continuing the use of this Website, you agree to indemnify,
                  defend, and hold harmless of Herbalicious2u and Passionation,
                  its officers, directors, employees, agents, licensor and
                  suppliers (collectively the “Service Providers”) from and
                  against all losses, expenses, damages and costs, including
                  reasonable legal and attorney’s fees, resulting from any
                  violation of these General Terms or any activity related to
                  your account (including negligent or wrongful conduct) by you
                  or any third-party accessing the Website using your Internet
                  account.
                </p>
                <p class="font-16 pb-3">Privacy and Security</p>
                <p class="font-16">
                  The use of the Website is also governed by our Privacy and
                  Security Policy, located on the web site and incorporated into
                  the General Terms.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">MISCELLANEOUS TERMS</p>
                <p class="font-20 fw-bold">ENFORCEMENT</p>
                <p class="font-16">
                  By accessing and using the Website, you agree that your access
                  to and use of the Website is subject to these General Terms,
                  as well as all applicable governing laws in Malaysia.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">BINDING NATURE</p>
                <p class="font-16">
                  The use of the Website by you constitutes your acceptance of
                  the General Terms and your continued use confirms that
                  acceptance.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">ENTIRE UNDERSTANDING</p>
                <p class="font-16">
                  In the event Herbalicious2u (or Passionation) failed to
                  exercise or enforce any right or provision of the General
                  Terms, it shall not be viewed as a waiver of such right or
                  provision.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">NO WAIVER</p>
                <p class="font-16">
                  In the event Passionation failed to exercise or enforce any
                  right or provision of the General Terms, it shall not be
                  viewed as a waiver of such right or provision.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">HEADINGS</p>
                <p class="font-16">
                  The section titles in the General Terms are for convenience
                  only and have no legal or contractual effect. The General
                  Terms shall operate to the fullest extent permissible by law.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">SEVERABILITY/ SALVATION CLAUSE</p>
                <p class="font-16 pb-3">
                  In the event that any of the provisions in the General Terms
                  is unlawful, void or unenforceable, that provision is deemed
                  severable from the General Terms and does not affect the
                  validity and enforceability of any remaining provisions in the
                  General Terms. Under such circumstances, the invalid provision
                  shall be reinterpreted or, if necessary, modified to come as
                  close as possible to its intended purpose.
                </p>
                <p class="font-16">
                  Any deviations of these provisions shall take effect only
                  subject to our express written confirmation.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">DISPUTES</p>
                <p class="font-16">
                  If there is any dispute about or involving Herbalicious2u (or
                  Passionation), you agree that the relevant laws of Malaysia
                  shall govern the dispute, without regard to conflict of law or
                  choice of law provisions and you agree to the exclusive
                  personal jurisdiction and venue in the state and federal
                  courts of Malaysia.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">TERMINATION</p>
                <p class="font-16">
                  The General Terms are applicable to you upon accessing the
                  Website and/or completing the registration or shopping
                  process. Passionation reserves the rights to terminate these
                  General Terms, or any of them, without notice at any time for
                  any reason. Provisions relating to Copyrighted Medias,
                  Limitation of Liability/ Disclaimer, Indemnification and
                  Miscellaneous Terms, shall survive any termination.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Modal -->
    <div
      class="modal fade"
      id="faq"
      tabindex="-1"
      aria-labelledby="faq"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div
            class="
              modal-body
              d-flex
              align-items-center
              flex-column
              postion-relative
            "
          >
            <img
              src="@/img/tnc_close.png"
              alt="footer modal close"
              class="tnc-close img-fluid"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div class="text-content">
              <h4 class="text-uppercase text-center pb-5">FAQ</h4>
              <div class="pb-4">
                <p class="font-20 fw-bold">About Us</p>
                <a
                  href=""
                  data-bs-toggle="modal"
                  data-bs-target="#about-moments"
                  @click="hidefaqmodal()"
                >
                  <p class="font-16">What is Moments by Passionation.co?</p>
                </a>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Orders</p>
                <div class="pb-3">
                  <p class="font-16 fw-bold">How do I place an order?</p>
                  <ol>
                    <li>
                      Start browsing on the website and click on the Add to cart
                      button for products you would like to order.
                    </li>
                    <li>
                      Once you’ve added all the products to the cart, click on
                      the shopping cart to proceed with checkout.
                    </li>
                    <li>Fill in the requested information</li>
                    <li>
                      Review your order and click on Place Order Now to make
                      payment.
                    </li>
                  </ol>
                </div>
                <div class="pb-3">
                  <p class="font-16 fw-bold">
                    How do I know if my order went through?
                  </p>
                  <p class="font-16">
                    Once you’ve successfully placed your order, you will receive
                    an email containing the details of your order.
                  </p>
                </div>
                <div class="">
                  <p class="font-16 fw-bold">
                    Can I make changes to or cancel my order once it’s been
                    placed?
                  </p>
                  <p class="font-16">
                    Once you successfully make an order, any changes to your
                    order will no longer be possible. We always suggest
                    reviewing your cart and shipping details carefully before
                    you check out!
                  </p>
                </div>
                <!--div>
                  <p class="font-16 fw-bold">
                    I want to purchase it as a gift and request for a personal
                    note. How do I go about it? Can you remove the
                    receipt/invoice as well?
                  </p>
                  <p class="font-16">
                    We do offer a free gifting note. Just key in your greeting
                    message in the Greeting Message box and let us know if you
                    would like to remove the receipt/ invoice under the Remark
                    box.
                  </p>
                </div-->
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Delivery</p>
                <div class="pb-3">
                  <p class="font-16 fw-bold">
                    How much is the shipping fee? And how long does it take to
                    process and ship out my order?
                  </p>
                  <p class="font-16">
                    Please refer
                    <a
                      href=""
                      data-bs-toggle="modal"
                      data-bs-target="#shipping-policy"
                      @click="hidefaqmodal()"
                      >here</a
                    >
                  </p>
                </div>
                <div>
                  <p class="font-16 fw-bold">How can I track my order?</p>
                  <p class="font-16">
                    You may check from your mailbox, we will notify you through
                    emails for your order progress.
                  </p>
                </div>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Payment</p>
                <div>
                  <p class="font-16 fw-bold">
                    What kind of payment method can I use at
                    https://moments.passionation.co/ ?
                  </p>
                  <p class="font-16">
                    Currently we accept debit/credit card payment via iPay88.
                  </p>
                </div>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Refunds, Returns and Exchanges</p>
                <div>
                  <p class="font-16 fw-bold">
                    What is the return and refund policy?
                  </p>
                  <p class="font-16">
                    Please refer
                    <a
                      href=""
                      data-bs-toggle="modal"
                      data-bs-target="#refund-policy"
                      @click="hidefaqmodal()"
                      >here</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Shipping Policy Modal -->
    <div
      class="modal fade"
      id="shipping-policy"
      tabindex="-1"
      aria-labelledby="shipping-policy"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div
            class="
              modal-body
              d-flex
              align-items-center
              flex-column
              postion-relative
            "
          >
            <img
              src="@/img/tnc_close.png"
              alt="footer modal close"
              class="tnc-close img-fluid"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div class="text-content">
              <h4 class="text-uppercase text-center pb-5">Shipping Policy</h4>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  Herbalicious2u Powered by Passionation
                </p>
                <p class="font-16">
                  Delivery charges will be calculated as follows:-
                </p>
              </div>
              <div class="pb-4">
                <div>
                  <p class="font-16 fw-bold">West Malaysia</p>
                  <p class="font-16">(Peninsular Malaysia)</p>
                  <p class="font-16">Delivery Charges</p>
                  <p class="font-16">For Order below RM65 - RM8.00</p>
                  <p class="font-16">For Order below RM65 - RM8.00</p>
                </div>
              </div>
              <div class="pb-4">
                <div class="pb-3">
                  <p class="font-16 fw-bold">East Malaysia</p>
                  <p class="font-16">(Sabah, Sarawak & Labuan)</p>
                  <p class="font-16">Delivery Charges</p>
                  <p class="font-16">For Order below RM100 - RM15.00</p>
                  <p class="font-16">For Order between RM100 - RM200 - RM10</p>
                  <p class="font-16">For Order above RM200 - FREE Delivery</p>
                </div>
                <div>
                  <ol>
                    <li>
                      Once the goods have been shipped, the customer will
                      receive a shipping confirmation by email, including the
                      tracking number.
                    </li>
                    <li>
                      Any goods damaged during shipment. Please contact our
                      customer service within 24 hours. If the order is overdue,
                      the default item is intact.
                    </li>
                    <li>
                      Orders are shipped on working days only (Monday – Friday,
                      excluding National holidays in Malaysia).
                    </li>
                    <li>
                      For in-stock items, the order will be processed and
                      shipped within 3 – 5 working days after order verification
                      and credit approval.
                    </li>
                    <li>We do not deliver to P.O. Box addresses.</li>
                    <li>
                      Orders will be processed and shipped once credit card
                      authorization is received.
                    </li>
                    <li>
                      International: We do not ship items purchased from this
                      website to any other destinations outside of Malaysia.
                    </li>
                    <li>
                      During the festive period, please allow more time for
                      delivery. We do apologize for the inconvenience caused.
                    </li>
                    <li>
                      If delivery is delayed due to the Customer’s undue delay
                      or unreasonable refusal to accept delivery or if the
                      Customer fails or refuses to collect the Products within
                      seven (7) days from the date of the second notification
                      from the courier service company, the Order will be deemed
                      null and void and the Customer shall bear all the relevant
                      cost incurred by Herbalicious2u (including but not limited
                      to the delivery cost and administrative charges).
                    </li>
                    <li>
                      Herbalicious2u shall use reasonable endeavors to deliver
                      Products of acceptable quality to the delivery address
                      specified by the Customer but Herbalicious2u cannot
                      guarantee any firm delivery time and Herbalicious2u shall
                      not be liable for any delay in its delivery services, if
                      the delay has been due to causes beyond the control of
                      Herbalicious2u.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Refund Policy Modal -->
    <div
      class="modal fade"
      id="refund-policy"
      tabindex="-1"
      aria-labelledby="refund-policy"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div
            class="
              modal-body
              d-flex
              align-items-center
              flex-column
              postion-relative
            "
          >
            <img
              src="@/img/tnc_close.png"
              alt="footer modal close"
              class="tnc-close img-fluid"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div class="text-content">
              <h4 class="text-uppercase text-center pb-5">
                Cancellation & Return Policy
              </h4>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  Herbalicious2u (Power by Passionation)
                </p>
              </div>
              <div class="pb-4">
                <div class="pb-3">
                  <p class="font-16 fw-bold">Return</p>
                  <p class="font-16">
                    The customer has seven (7) calendar days to return an item
                    from the date he/she receives our products.
                  </p>
                </div>
                <div class="pb-3">
                  <p class="font-16">
                    To be eligible for a return, we require the following:-
                  </p>
                  <ul>
                    <li>
                      The packaging item must be intact ie. in the original
                      condition as when the item was purchased from
                      Herbalicious2u (Powered by Passionation).
                    </li>
                    <li>
                      The item needs to have a receipt or proof of purchase.
                    </li>
                    <li>
                      Please keep the returned goods intact and do not stick or
                      write directly on the goods.
                    </li>
                  </ul>
                </div>
                <div>
                  <p class="font-16">
                    If the customer finds that the goods are damaged during
                    shipping, please contact our customer service within 24
                    hours. If the order is overdue, the default item is intact.
                  </p>
                </div>
              </div>
              <div class="pb-4">
                <div class="pb-3">
                  <p class="font-16 fw-bold">Refund</p>
                  <p class="font-16">
                    When Herbalicious2u receives the item, we will inspect it
                    and notify the customer on the status of the refund.
                  </p>
                </div>
                <div class="pb-3">
                  <p class="font-16">
                    We may, at our sole discretion, accept refunds of the goods
                    in the following events:-
                  </p>
                  <ul>
                    <li>
                      The items do not match the description by which they were
                      sold.
                    </li>
                    <li>Wrong items from the ones ordered.</li>
                    <li>Incorrect quantity of items supplied.</li>
                    <li>The items are out of stock.</li>
                  </ul>
                </div>
                <div class="pb-3">
                  <p class="font-16">
                    Herbalicious2u refunds may take up to 14 to 21 working days.
                    When returning a product for a refund, the customer will be
                    asked for his/her name, address and signature as
                    authorization for the refund transaction into his/her bank
                    account or credit card.
                  </p>
                </div>
                <div>
                  <p class="font-16">
                    After seven (7) days of purchase, any requests for a refund
                    will not be entertained.
                  </p>
                </div>
              </div>
              <div class="pb-4">
                <div class="pb-3">
                  <p class="font-16 fw-bold">Shipping for Return</p>
                  <p class="font-16">
                    If the returned item is due to Herbalicious2u’s mistake,
                    Herbalicious2u will be responsible for the shipping cost.
                  </p>
                </div>
                <div>
                  <p class="font-16">
                    The customer will be responsible for the payment of the
                    shipping cost for the returned item. Shipping costs are
                    non-refundable.
                  </p>
                </div>
              </div>
              <div class="pb-4">
                <div>
                  <p class="font-16 fw-bold">Returned items location</p>
                  <p class="font-16">
                    Herbalicious2u, A-03a-06, Pinnacle Kelana Jaya, No 2, Zenith
                    Corporate Park, Jalan SS7/26, 47301 Petaling Jaya, Selangor
                    D.E. Malaysia.
                  </p>
                </div>
              </div>
              <div class="pb-4">
                <div>
                  <p class="font-16 fw-bold">Item Not Eligible</p>
                  <p class="font-16">
                    Products on sale are non-returnable / refundable
                  </p>
                </div>
              </div>
              <div class="pb-4">
                <div>
                  <p class="font-16 fw-bold">Questions About A Return?</p>
                  <p class="font-16">
                    If you have any questions on how to return your items to us,
                    please contact us at
                    <a href="mailto: info@herbalicious2u.com"
                      >info@herbalicious2u.com</a
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Privacy Policy Modal -->
    <div
      class="modal fade"
      id="privacy"
      tabindex="-1"
      aria-labelledby="privacy"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content">
          <div
            class="
              modal-body
              d-flex
              align-items-center
              flex-column
              postion-relative
            "
          >
            <img
              src="@/img/tnc_close.png"
              alt="footer modal close"
              class="tnc-close img-fluid"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
            <div class="text-content">
              <h4 class="text-uppercase text-center pb-5">Privacy Policy</h4>
              <div class="pb-4">
                <p class="font-20 fw-bold">Accountability</p>
                <p class="font-16">
                  We will be responsible for all personal data collected. All
                  personal data collected will be used and processed fairly and
                  lawfully while in our possession or custody. We assure all our
                  customers that we would be accountable for our organization's
                  compliance with our Privacy Policy.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Accuracy</p>
                <p class="font-16 pb-3">
                  We assure our customers that all personal information
                  collected is accurate and kept up to date. We do not maintain
                  duplicate copies of personal information in different systems.
                </p>
                <p class="font-16 pb-3">
                  We do not share this information with external parties except
                  to the extent necessary to complete the order or to provide
                  services where the external party is acting on our behalf and
                  has no independent right to use the information we provide.
                </p>
                <p class="font-16">
                  We maintain the privacy of your information by having
                  appropriate security safeguards in place and adhere to
                  policies that prevent the unauthorized use of your personal
                  information.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Consent</p>
                <p class="font-16">
                  We do not collect sensitive information from our customers. We
                  assure all customers that all personal information collected
                  would be used or disclosed only for the purposes for which it
                  was collected.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Challenging Compliance</p>
                <p class="font-16">
                  Our mechanisms and processes are in place to receive and
                  address complaints or inquiries about our policies and
                  procedures relating to the handling of personal data.
                  Appropriate measures will be taken to amend policies and
                  procedures if a complaint is found to be justified.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  Limiting Use, Disclosure and Retention
                </p>
                <p class="font-16 pb-3">
                  We will not disclose, share, transfer, sell or rent personally
                  identifiable information to any 3rd party. We do not send
                  unsolicited marketing email to our customers. Customers will
                  occasionally receive email on special promotions we hold. Out
                  of respect for the privacy of our users, users may opt-out of
                  receiving these communications by choosing to unsubscribe
                  themselves.
                </p>
                <p class="font-16 pb-3">
                  We do not keep personal data for longer than is necessary for
                  those purposes for which they are collected.
                </p>
                <p class="font-16 pb-3">
                  We have developed guidelines and implemented procedures to
                  govern the destruction of personal data that are no longer
                  required to fulfill the identified purposes.
                </p>
                <p class="font-16 pb-3">
                  We do not use web-bugs or any other tracking technologies to
                  collect information from users of our website.
                </p>
                <p class="font-16">
                  We will not display or make publicly available, whether
                  through online directories, customer lists or otherwise, the
                  personally identifiable information collected.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Safeguards</p>
                <p class="font-16">
                  We assure our customers that appropriate security safeguards
                  are in place to protect personal data against unauthorized
                  access, misuse, disclosure, copying, use, alteration,
                  accidental loss or theft, destruction or damage. Only
                  authorized personnel have access to our systems. Consultants,
                  contractors or other temporary employees do not have access to
                  the data.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">Security</p>
                <p class="font-16">
                  Passionation is committed to protecting the confidentiality
                  and integrity of personal information you submit. Our secure
                  server encrypts all personal information (including name,
                  address, credit card number and contact details) so that it
                  cannot be read as the information travels over the Internet.
                  The advanced technology employed by Passionation ensures that
                  it is virtually impossible for our users' credit card
                  information to be used fraudulently.
                </p>
              </div>
              <div class="pb-4">
                <p class="font-20 fw-bold">
                  Secure Socket Layer (SSL) Encryption
                </p>
                <p class="font-16 pb-3">
                  Industry standard security measures are used which is made
                  available through your browser called Secure Socket Layer
                  (SSL). SSL protocol is used to safeguard your sensitive
                  personal information, including your credit card number,
                  during online transactions. Using this widely accepted form of
                  encryption, your transaction is secured when the information
                  travels from your personal computer to the computer processing
                  your request.
                </p>
                <p class="font-16">
                  As users enter the payment information, it is captured on a
                  page that uses the SSL protocol by default. All personal and
                  financial information is encrypted as it travels over the
                  Internet. All financial information is stored in encrypted
                  form on our servers. The server is also not accessible through
                  the Internet. Credit card security is an issue of top priority
                  for our company.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterModal",

  methods: {
    hidefaqmodal: function () {
      this.$parent.hidefaqmodal();
    },
  },
};
</script>